import React from "react";
import { Recruitment } from "./pages/Recruitment";
export function App() {
  return <Recruitment data-id="element-0" data-mp="35ckbubl5pal3" />;
}